import type { ReactNode } from "react";
import type { Tool } from "../App";
import Icon, { type IconName } from "../components/Icon";
import InstallHint from "../components/InstallHint";

// Each tool as a white card with its drawing in a blush tile, as on the order form and the soulcake.eu menu:
// box = Matsentralen box tracker, warehouse = Inventory (stock), shelves = Items, calendar = Scheduler.
function ToolCard({
  icon,
  title,
  delay = 0,
  onClick,
  children,
}: {
  icon: IconName;
  title: string;
  delay?: number;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      style={{ animationDelay: `${delay}ms` }}
      className="pop-in flex min-h-24 w-full items-center gap-4 rounded-[18px] border border-line-soft bg-white px-4 py-4 text-left shadow-card transition active:scale-[0.98]"
    >
      <span className="flex size-14 shrink-0 items-center justify-center rounded-[17px] bg-blush text-rose-ink">
        <Icon name={icon} size={28} />
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="text-[17px] font-bold tracking-[-0.01em]">{title}</span>
        <span className="text-[13px] text-ink-faint">{children}</span>
      </span>
      <Icon name="chevronRight" size={20} className="shrink-0 text-ink-faint" />
    </button>
  );
}

export default function Launcher({ onPick }: { onPick: (tool: Tool) => void }) {
  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col items-center justify-center gap-6 px-5 py-6">
      <img src="/logo.png" alt="Soulcake" className="h-16 w-auto" />
      <h1 className="text-[26px] font-bold tracking-[-0.02em] text-[#3a1c25]">Where to?</h1>
      <div className="flex w-full flex-col gap-3">
        <ToolCard icon="box" title="Matsentralen" onClick={() => onPick("boxes")}>
          Box tracker
        </ToolCard>
        <ToolCard icon="warehouse" title="Inventory" delay={60} onClick={() => onPick("stock")}>
          Stock, shop requests and when to order
        </ToolCard>
        <ToolCard icon="shelves" title="Items" delay={120} onClick={() => onPick("items")}>
          Photograph and find what's in the storehouse
        </ToolCard>
        <ToolCard icon="calendarCheck" title="Scheduler" delay={180} onClick={() => onPick("scheduler")}>
          Pickups, deliveries and tasks
        </ToolCard>
      </div>
      <InstallHint />
    </div>
  );
}
